import { render, staticRenderFns } from "./cisTip.vue?vue&type=template&id=08224e15&scoped=true"
import script from "./cisTip.vue?vue&type=script&lang=js"
export * from "./cisTip.vue?vue&type=script&lang=js"
import style0 from "./cisTip.vue?vue&type=style&index=0&id=08224e15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08224e15",
  null
  
)

export default component.exports